import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPaysafeCard = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M29 16.005v-.01h-.002a.3.3 0 0 0-.027-.124.3.3 0 0 0-.075-.106l-8.313-7.717A.2.2 0 0 0 20.46 8h-.052c-.097 0-.175.072-.175.162v7.833a.3.3 0 0 0-.027-.124.3.3 0 0 0-.076-.106l-8.261-7.67A.37.37 0 0 0 11.621 8h-.01a.37.37 0 0 0-.248.096l-8.26 7.672a.3.3 0 0 0-.103.23v.008c0 .086.037.168.101.23l8.266 7.669c.065.06.153.095.246.095h.01a.37.37 0 0 0 .248-.095l8.261-7.67a.3.3 0 0 0 .102-.23v7.832a.15.15 0 0 0 .052.115.18.18 0 0 0 .124.048h.052a.2.2 0 0 0 .123-.048l8.313-7.718a.3.3 0 0 0 .102-.23"
      />
    </svg>
  );
};
export default SvgPaysafeCard;
